import Em from 'ember';
export default Em.Component.extend();